<nav id="menu-services" trapFocus (keyup.escape)="close()">
    <div id="services-header">
        <div id="services-header-icon">
            <img
                width="19"
                height="13"
                [ngSrc]="'assets/images/app-icons/transnetyx-icon.svg'"
                [alt]="'transnetyx' | translate"
                id="transnetyx-icon" />
        </div>
        <p>{{ 'profileMenu.servicesPanelHeader' | translate }}</p>
    </div>
    <a id="automated-genotyping-link" [href]="automatedGenotypingUrl" target="_blank" autofocus>
        <img
            width="30"
            height="30"
            [ngSrc]="'assets/images/app-icons/automated-genotyping-icon.svg'"
            alt=""
            id="automated-genotyping-icon" />
        <label for="automated-genotyping-icon" id="automated-genotyping-label">Automated Genotyping</label>
    </a>
    <a id="genetic-monitoring-link" [href]="geneticMonitoringUrl" target="_blank" autofocus>
        <img
            width="30"
            height="30"
            [ngSrc]="'assets/images/app-icons/genetic-monitoring-icon.svg'"
            alt=""
            id="genetic-monitoring-icon" />
        <label for="genetic-monitoring-icon" id="genetic-monitoring-label">Genetic Monitoring</label>
    </a>
    <a id="microbiome-link" [href]="microbiomeUrl" target="_blank">
        <img
            width="30"
            height="30"
            [ngSrc]="'assets/images/app-icons/microbiome-icon.svg'"
            alt=""
            id="microbiome-icon" />
        <label for="microbiome-icon" id="microbiome-label">Microbiome</label>
    </a>
    <a id="colony-and-ami-link" [href]="colonyUrl" target="_blank">
        <img
            width="30"
            height="30"
            [ngSrc]="'assets/images/app-icons/colony-icon.svg'"
            alt=""
            id="colony-and-ami-icon" />
        <label for="colony-and-ami-icon" id="colony-and-ami-label">Colony + AMI</label>
    </a>
    <a id="tissue-link" [href]="tissueUrl" target="_blank">
        <img width="30" height="30" [ngSrc]="'assets/images/app-icons/tissue-icon.svg'" alt="" id="tissue-icon" />
        <label for="tissue-icon" id="tissue-label">Tissue</label>
    </a>
    <a id="tag-center-link" [href]="tagCenterUrl" target="_blank">
        <img
            width="30"
            height="30"
            [ngSrc]="'assets/images/app-icons/tag-center-icon.svg'"
            alt=""
            id="tag-center-icon" />
        <label for="colony-and-ami-icon" id="tag-center-label">TAGCenter</label>
    </a>
</nav>
